"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { portalLoginHref } from "@/lib/portal-public-url";

function getLang(searchParams: ReturnType<typeof useSearchParams>) {
  const lang = searchParams.get("lang");
  return lang === "de" ? "de" : "en";
}

export function SiteFooter() {
  const searchParams = useSearchParams();
  const lang = getLang(searchParams);

  return (
    <footer className="site-footer site-footer--public">
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <div>
            <div className="site-footer__brand">Floor Care &amp; Sales LLC</div>
            <p className="site-footer__muted">
              {lang === "de"
                ? "Technologieorientiertes Unternehmen für spezialisierte Systeme, industrielle Anwendungen und zukünftige Innovationsfelder."
                : "Technology-oriented company for specialized systems, industrial applications, and future innovation fields."}
            </p>
          </div>

          <div>
            <div className="site-footer__heading">
              {lang === "de" ? "Navigation" : "Navigation"}
            </div>
            <div className="site-footer__links site-footer__links--column">
              <Link href={`/?lang=${lang}`}>Home</Link>
              <Link href={`/technology?lang=${lang}`}>Technology</Link>
              <a href={`/?lang=${lang}#industries`}>Industries</a>
              <a href={`/?lang=${lang}#contact`}>Contact</a>
            </div>
          </div>

          <div>
            <div className="site-footer__heading">
              {lang === "de" ? "Zugang" : "Access"}
            </div>
            <div className="site-footer__links site-footer__links--column">
              <a href={portalLoginHref(lang)}>Login</a>
              <a href="mailto:info@fl-care.com">info@fl-care.com</a>
            </div>
          </div>
        </div>

        <div className="site-footer__bottom">
          <span>© Floor Care &amp; Sales LLC</span>
          <span>
            {lang === "de"
              ? "Vorschauversion – öffentliche Freigabe nur nach ausdrücklicher Freigabe"
              : "Preview version – public release only after explicit approval"}
          </span>
        </div>
      </div>
    </footer>
  );
}
